<template>
  <div class="flex flex-col h-full overflow-y-hidden">
    <form @submit.prevent="handleSubmit(handleProceed)()">
      <div class="form-fields">
        <div class="grid grid-cols-2 gap-4 w-11/12 mx-auto">
          <VFormInput
            placeholder="Enter new title"
            label="Add New Title*"
            @update="value => handleSetField('title', value)"
            :error="errors.title"
            :initialValue="editableResource.title"
            :reset="!fieldsData.title"
            :classes="{ field: 'mb-0 ', fieldContainer: 'mb-0' }"
          />
          <VFormInput
            placeholder="Enter new order"
            label="Add New Order*"
            @update="value => handleSetField('order', value)"
            :error="errors.order"
            :initialValue="editableResource.order"
            :reset="!fieldsData.order"
            :classes="{ field: 'mb-0 ', fieldContainer: 'mb-0' }"
          />
          <VFormInput
            placeholder="Url"
            label="Add Url or choose a File"
            @update="value => handleSetField('url', value)"
            :error="errors.url"
            :initialValue="editableResource.url"
            :reset="!fieldsData.url"
            :classes="{ field: 'mb-0 ', fieldContainer: 'mb-0' }"
          />
          <div>
            <VFormUpload
              :accept="['application/pdf', 'image/*', '.dst']"
              :initialValue="editableResource.file_path"
              :initialSrc="editableResource.file_path"
              @upload="value => handleSetField('file', value[0])"
              :reset="resetField"
            />
          </div>

          <button type="submit" class="text-white bg-gray-900 rounded py-4">
            {{ editable ? 'EDIT' : 'ADD' }}
          </button>
        </div>
      </div>
    </form>
    <ul class="px-5 overflow-y-auto">
      <li
        class="flex items-center justify-between px-4 py-4 border-b border-ricoma-gray-200 hover:bg-ricoma-gray-100"
      >
        <div class="w-3/12 font-bold text-center">Order</div>
        <div class="w-3/12 font-bold text-center">Title</div>
        <div class="w-3/12 font-bold text-center">Link/Url</div>
        <div class="w-3/12 font-bold text-center">Actions</div>
      </li>
      <li
        v-for="(resource, index) in resources"
        :key="`resource-${index}`"
        class="flex items-center justify-between px-4 py-4 border-b border-ricoma-gray-200 hover:bg-ricoma-gray-100"
      >
        <div class="w-3/12 text-center">{{ resource.order }}</div>
        <div class="w-3/12 text-center">{{ resource.title }}</div>
        <div class="w-3/12 text-center">
          {{ resource.file_path ? resource.file_path : resource.url }}
        </div>
        <div class="flex justify-center w-3/12">
          <button class="mr-2 button-round edit" @click="handleSetEditable(resource)">
            <VSvgIcon name="pencil" class="h-5" />
          </button>
          <button class="button-round delete" @click="handleDeleteResource(resource.id)">
            <VSvgIcon name="trash" class="h-5" />
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { formMixin } from '@/mixins';

import VFormInput from '@/components/base/VFormInput';
import VSvgIcon from '@/components/base/VSvgIcon';
import VFormUpload from '@/components/base/VFormUpload';

export default {
  name: 'ProductResourceForm',
  components: {
    VFormInput,
    VSvgIcon,
    VFormUpload,
  },
  props: {
    initialValues: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    resources: {
      type: Array,
      required: false,
      default: () => [],
    },
    product_id: {
      type: Number,
      required: true,
    },
    language: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  mixins: [
    formMixin(
      {
        title: '',
        order: '',
        file: '',
        url: '',
      },
      ['url', 'file'],
    ),
  ],
  data() {
    return {
      editableResource: {},
      resetField: false,
    };
  },
  computed: {
    editable() {
      return this.editableResource && !!Object.keys(this.editableResource).length;
    },
  },
  methods: {
    handleSetEditable({ ...res }) {
      this.editableResource = {
        ...res,
      };
    },
    handleReset() {
      this.handleResetFields();
      this.handleResetErrors();
      this.editableResource = {};
      this.resetField = false;
    },
    async handleAddResource({ ...data }) {
      const { code: lang_code } = this.language;
      const requestData = {
        ...data,
        product_id: this.product_id,
        lang_code,
      };
      const formData = new FormData();
      Object.keys(requestData).forEach(key => formData.append(key, requestData[key]));

      const result = await this.$http.post(`admin/product-resources/`, formData);
      this.resources.push(result.data.data);
      this.handleReset();
    },
    async handleUpdateResource({ id, ...data }) {
      const { code: lang_code } = this.language;
      const requestData = {
        ...data,
        product_id: this.product_id,
        lang_code,
      };
      const formData = new FormData();
      Object.keys(requestData).forEach(key => formData.append(key, requestData[key]));
      const result = await this.$http.post(`admin/product-resources/${id}`, requestData);

      const objIndex = this.resources.findIndex(resource => resource.id === id);
      this.resources[objIndex] = result.data.data;
      this.handleReset();
    },
    async handleDeleteResource(id) {
      await this.$http.delete(`admin/product-resources/${id}`);
      this.resources.splice(this.resources.indexOf(id), 1);
    },
    handleProceed(data) {
      this.resetField = true;
      this.editable
        ? this.handleUpdateResource({
            id: this.editableResource.id,
            title: data.title,
            order: data.order,
            url: data.url,
            file_path: data.file_path,
          })
        : this.handleAddResource(data);
    },
  },
};
</script>
